<template>
  <div class="city-select-container">
    <lk-cascader ref="canscader" :transfer='true' :disabled='disabled' :data='formatList' @on-change='hanleChange'>
      <div class="canscader-show" :class="{'no-border': disabled && readOnly}">
        <div class="place-holder" v-if="!checks.length">{{placeHolder}}</div>
        <template v-else-if="!readOnly">
          <lk-tag @click.native="clickTag" :closable="!disabled" @on-close="handleClose(item.value)" v-for="item in checks" :key="item.value">{{item.label}}</lk-tag>
        </template>
        <template v-else>
          <span v-for="(item, index) in checks" :key="item.value">
            {{index === checks.length-1 ? item.label : `${item.label},`}}
          </span>
        </template>
      </div>
    </lk-cascader>
  </div>
</template>

<script>

export default {
  name: 'citySelect',
  props: {
    placeHolder: {
      type: String,
      default: '请选择'
    },
    value: {
      type: Array,
      default: () => {
        return [];
      },
    },
    labels: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    // disabled = true 且 readOnly = true 时生效，已选项不再以tag的形式展示， 以逗号分隔符形式展示
    readOnly: {
      type: Boolean,
      default: false,
    },
    disableIds: {
      type: Array,
      default: () => {
        return [122, 133];
      },
    },
    list: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {

    }
  },
  computed: {
    checks() {
      return this.getChecks(this.value, this.list);   
    },
    formatList() {
      return this.getFormatList(this.disableIds, this.list);
    },
  },
  watch: {
    checks: {
      immediate: true,
      deep: true,
      handler(newVal) {
        const arr = [];
        if (newVal && newVal.length) {
          newVal.forEach(item => {
            arr.push(item.label);
          })
        }
        this.$emit('update:labels', arr.join(','));
      }
    }
  },
  methods: {
    getFormatList(disableIds, list) {
      const that = this;
      this.recurrenceList(
        disableIds,
        list,
        (item) => {
          that.$set(item, 'disabled', true);
        },
        (item) => {
          that.$set(item, 'disabled', false);
        }
      );
      return list;
    },
    hanleChange(val) {
      val = val.pop();
      if (!this.value.includes(val)) {
        this.$emit('input', [...this.value, val]);
      }
    },
    // 显示已选项
    getChecks(values, list) {
      const r = [];
      this.recurrenceList(values, list, (item) => {
        r.push({label: item.label, value: item.value});
      });
      r.sort((a, b) => {
        return values.indexOf(a.value) - values.indexOf(b.value);
      })
      return r;
    },
    recurrenceList(values, list ,matchCallBack, notMatchCallBack) {
      const that = this;
      list.forEach(item => {
        if (values && values.includes(item.value)) {
          matchCallBack && matchCallBack(item);
        } else {
          notMatchCallBack && notMatchCallBack(item);
        }
        if (item.children && item.children.length) {
          that.recurrenceList(values, item.children, matchCallBack, notMatchCallBack);
        }
      });
    },
    handleClose(value) {
      if (this.disabled) {
        return;
      }
      const index = this.value.indexOf(value);
      if (index !== -1) {
        this.value.splice(index, 1);
        this.$emit('input', this.value);
      }
    },
    clickTag() {
      this.$refs.canscader.toggleOpen();
    },
  }
}
</script>

<style lang="less" scoped>
.city-select-container {
  min-width: 120px;
  position: relative;
  /deep/ .ct-cascader.ivu-cascader.ivu-cascader-size-default {
    opacity: 0;
  }
  /deep/ .ct-cascader.ivu-cascader.ivu-cascader-size-default.ivu-cascader-visible {
    opacity: 0;
  }
  .canscader-show {
    min-height: 32px;
    line-height: 32px;
    cursor: pointer;
    border: 1px solid #dcdee2;
    padding: 0 4px;
    border-radius: 4px;
    .place-holder{
      color: #d6d6d6;
      font-size: 12px;
    }
  }
  .no-border {
    border: none;
  }
}

</style>
